import BodyLoading from './BodyLoading';

export const bodyLoadingCreator = (containerClassName) => {
  const loadingInstance = new BodyLoading(containerClassName);
  const show = loadingInstance.show.bind(loadingInstance);
  const hide = loadingInstance.hide.bind(loadingInstance);
  const clear = loadingInstance.clear.bind(loadingInstance);
  return { show, hide, clear };
};

export default BodyLoading;
